


























































import { Component, Prop, Watch, Mixins } from 'vue-property-decorator'
import { TRANSFORMERS } from '@/helpers/transformer'
import { LibraryMixin } from '@/mixins'
import { Track } from '@/classes/track'

@Component({})
export default class Transformers extends Mixins(LibraryMixin) {
  @Prop()
  value: TRANSFORMERS

  model: TRANSFORMERS = this.value

  get tracks(): Track[] {
    return this.$store.getters['library/selectedTracks']
  }

  setTransformer(t: TRANSFORMERS) {
    this.model = t
  }

  async pipeToStoreLinks() { // Not a transformer because it uses the router and doesnt transform anything
    if (this.tracks) {
      this.$store.commit('storelinks/setCombos', this.tracks.map(x => [x.title, x.artist]))

      await this.$router.replace({
        name: 'store links input',
        query: {
          activeTab: '1'
        }
      })
    }
  }

  @Watch('model')
  watchModel(m: TRANSFORMERS) {
    this.$emit('input', m)
  }

  @Watch('value')
  watchValue(v: TRANSFORMERS) {
    this.model = v
  }
}
